module.exports = __webpack_public_path__ + "static/img/PC-4.f0260d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/PC-4.png
// module id = hRD0
// module chunks = 0